document.addEventListener("DOMContentLoaded", function () {
	const button = document.querySelector(".js-newsletter-toggle");
	const form = document.querySelector(".newsletter-form-wrapper");
	const animationSpace = document.querySelector(".newsletter-form-animation-space");
	animationSpace.style.height = `${form.scrollHeight}px`;
	if (button && form) {
		form.style.height = `${form.scrollHeight}px`;
		button.addEventListener("click", function (e) {
			e.preventDefault();
			form.classList.toggle("is-active");
			button.classList.toggle("is-active");
			setTimeout(() => {
				form.querySelector('input[type="email"]').focus();
			}, 600);
		});
		window.addEventListener("resize", function () {
			form.style.height = `${form.scrollHeight}px`;
			animationSpace.style.height = `${form.scrollHeight}px`;
		});
	}
});